export default "__VITE_ASSET__3a712415__"